import { openNewTab, validateWindowSize } from '../helpers';

export default function cardWidget() {
  const widgetName = 'cardWidget';
  const widgetOpts = cardWidgetOpts;
  const $widget = $(`#${widgetName}`);
  const wrapContainerClass = 'cardWidget-container-wrapper';

  return saffire.widgets.cardWidget($($widget), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    scriptPath: widgetOpts.scriptPath,
    link: validateWindowSize(800) ? [] : ['all'],
    showDescription: true,
    hasImages: true,
    lazyLoadImages: true,
    imageIsBackground: true,
    textOverImage: true,
    maxItemsVisible: 8,
    itemsPerPanel: 1,

    cardWidgetLoaded: function (data, _owl, hasData) {
      if (hasData) {
        $widget.wrap(
          `<div class="${wrapContainerClass}"><div class="inner-container"></div></div>`,
        );
        createCustomCards(data.items);
      } else {
        $(`.${wrapContainerClass}`).remove();
      }
    },
  });

  function createCustomCards(widgetData) {
    $widget.find('.card-content').remove();

    $widget.find('.card-widget-item').each(function (x) {
      const { Title, URL } = widgetData[x];
      const $cardItem = $(this);

      $cardItem.append(`
          <div class="card-content">
            <div class="widget-title-wrapper">
              <span class="widget-title">
                ${Title}</span>
              </div>
          </div>
          `);

      if (URL == null) {
        $cardItem.addClass('void-link');
        $cardItem.removeAttr('href');
      } else {
        $cardItem
          .find('.image-container')
          .append(`<a href="${URL}" class="button" tabindex="0" ${openNewTab(URL)}>More</a>`);
      }
    });
  }
}
